import { action_options, app_modules } from "helpers/apps_modules_list";
import Category from "pages/Master/Category/Category";
import CategoryForm from "pages/Master/Category/CategoryForm";
import SubCategory from "pages/Master/Sub-Category/Sub-Category";
import SubCategoryForm from "pages/Master/Sub-Category/Sub-CategoryForm";
import UnitForm from "pages/Master/Unit/UnitForm";
import Unit from "pages/Master/Unit/Unit";
import Gst from "pages/Master/GST/GST";
import GSTForm from "pages/Master/GST/GSTForm";
import HSNCode from "pages/Master/HSNCode/HSNCode";
import HSNCodeForm from "pages/Master/HSNCode/HSNCodeForm";
import Item from "pages/Master/Items/Item";
import ItemForm from "pages/Master/Items/ItemsForm";
import ItemDetailsPage from "pages/Master/Items/ItemDetailsPage";
import SupplierMasterForm from "pages/Master/Supplier/Form";
import SupplierMaster from "pages/Master/Supplier/List";
import SupplierViewDetails from "pages/Master/Supplier/ViewDetails";
import WarehouseMasterForm from "pages/Master/Warehouse/Form";
import WarehouseMaster from "pages/Master/Warehouse/List";
import ConfigureWarehouse from "pages/Master/Warehouse/ConfigureWarehouse";
import Labour from "pages/Master/Labour/Labour";
import LabourForm from "pages/Master/Labour/LabourForm";
import Customer from "pages/Master/Customer/Customer";
import CustomerForm from "pages/Master/Customer/CustomerForm";
import CustomerDetails from "pages/Master/Customer/CustomerDetails";

const MasterRoutes: any = [
  // Category
  {
    path: "/category",
    name: "Category",
    component: <Category />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.category,
      action: action_options?.view,
    },
  },
  {
    path: "/add-category",
    name: "Add Category",
    component: <CategoryForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.category,
      action: action_options?.create,
    },
  },
  {
    path: "/edit-category/:id",
    name: "Edit Category",
    component: <CategoryForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.category,
      action: action_options?.update,
    },
  },

  // SubCategory
  {
    path: "/sub-category",
    name: "Sub Category",
    component: <SubCategory />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.subcategory,
      action: action_options?.view,
    },
  },
  {
    path: "/add-sub-category",
    name: "Add Sub Category",
    component: <SubCategoryForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.subcategory,
      action: action_options?.create,
    },
  },
  {
    path: "/edit-sub-category/:id",
    name: "Edit Sub Category",
    component: <SubCategoryForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.subcategory,
      action: action_options?.update,
    },
  },

  // Unit
  {
    path: "/unit",
    name: "Unit",
    component: <Unit />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.unit,
      action: action_options?.view,
    },
  },
  {
    path: "/add-unit",
    name: "Add Unit",
    component: <UnitForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.unit,
      action: action_options?.create,
    },
  },
  {
    path: "/edit-unit/:id",
    name: "Edit Unit",
    component: <UnitForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.unit,
      action: action_options?.update,
    },
  },

  // GST
  {
    path: "/gst",
    name: "GST",
    component: <Gst />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.gst,
      action: action_options?.view,
    },
  },
  {
    path: "/add-gst",
    name: "Add GST",
    component: <GSTForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.gst,
      action: action_options?.create,
    },
  },
  {
    path: "/edit-gst/:id",
    name: "Edit GST",
    component: <GSTForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.gst,
      action: action_options?.update,
    },
  },

  // HSN Code
  {
    path: "/hsn-codes",
    name: "HSN Code",
    component: <HSNCode />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.hsn_code,
      action: action_options?.view,
    },
  },
  {
    path: "/add-hsn-code",
    name: "Add HSN Code",
    component: <HSNCodeForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.hsn_code,
      action: action_options?.create,
    },
  },
  {
    path: "/edit-hsn-code/:id",
    name: "Edit HSN Code",
    component: <HSNCodeForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.hsn_code,
      action: action_options?.update,
    },
  },

  // Items
  {
    path: "/item",
    name: "Item",
    component: <Item />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.item,
      action: action_options?.view,
    },
  },
  {
    path: "/add-item",
    name: "Add Item",
    component: <ItemForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.item,
      action: action_options?.create,
    },
  },
  {
    path: "/edit-item/:id",
    name: "Edit Item",
    component: <ItemForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.item,
      action: action_options?.update,
    },
  },
  {
    path: "/item-details/:id",
    name: "Item Details",
    component: <ItemDetailsPage />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.item,
      action: action_options?.view,
    },
  },
 

  // Suppliers
  {
    path: "/supplier-list",
    name: "SupplierList",
    component: <SupplierMaster />,
    permissions: {
      app_name: app_modules?.master?.app_name,
      module_name: app_modules?.master.modules?.suppliers,
      action: action_options?.view,
    },
  },
  {
    path: "/add-supplier",
    name: "AddSupplier",
    component: <SupplierMasterForm />,
    permissions: {
      app_name: app_modules?.master?.app_name,
      module_name: app_modules?.master.modules?.suppliers,
      action: action_options?.create,
    },
  },
  {
    path: "/edit-supplier/:id",
    name: "EditSupplier",
    component: <SupplierMasterForm />,
    permissions: {
      app_name: app_modules?.master?.app_name,
      module_name: app_modules?.master.modules?.suppliers,
      action: action_options?.update,
    },
  },
  {
    path: "/view-supplier/:id",
    name: "ViewSupplier",
    component: <SupplierViewDetails />,
    permissions: {
      app_name: app_modules?.master?.app_name,
      module_name: app_modules?.master.modules?.suppliers,
      action: action_options?.view,
    },
  },

  // Warehouses
  {
    path: "/warehouse-list",
    name: "WarehouseList",
    component: <WarehouseMaster />,
    permissions: {
      app_name: app_modules?.master?.app_name,
      module_name: app_modules?.master.modules?.warehouse,
      action: action_options?.view,
    },
  },
  {
    path: "/add-warehouse",
    name: "AddWarehouse",
    component: <WarehouseMasterForm />,
    permissions: {
      app_name: app_modules?.master?.app_name,
      module_name: app_modules?.master.modules?.warehouse,
      action: action_options?.create,
    },
  },
  {
    path: "/edit-warehouse/:id",
    name: "EditWarehouse",
    component: <WarehouseMasterForm />,
    permissions: {
      app_name: app_modules?.master?.app_name,
      module_name: app_modules?.master.modules?.warehouse,
      action: action_options?.update,
    },
  },
  {
    path: "/configure-warehouse/:id",
    name: "ConfigureWarehouse",
    component: <ConfigureWarehouse />,
    permissions: {
      app_name: app_modules?.master?.app_name,
      module_name: app_modules?.master.modules?.warehouse,
      action: action_options?.update,
    },
  },

   // Labour
   {
    path: "/labour",
    name: "Labour",
    component: <Labour />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.labour,
      action: action_options?.view,
    },
  },
  {
    path: "/add-labour",
    name: "Add Labour",
    component: <LabourForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.labour,
      action: action_options?.create,
    },
  },
  {
    path: "/edit-labour/:id",
    name: "Edit Labour",
    component: <LabourForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.labour,
      action: action_options?.update,
    },
  },

  // Customer
  {
    path: "/customer",
    name: "Customer",
    component: <Customer />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.customer,
      action: action_options?.view,
    },
  },
  {
    path: "/add-customer",
    name: "Add Customer",
    component: <CustomerForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.customer,
      action: action_options?.create,
    },
  },
  {
    path: "/edit-customer/:id",
    name: "Edit Customer",
    component: <CustomerForm />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.customer,
      action: action_options?.update,
    },
  },
  {
    path: "/customer-details/:id",
    name: "Customer Details",
    component: <CustomerDetails />,
    permissions: {
      app_name: app_modules.master.app_name,
      module_name: app_modules.master.modules.customer,
      action: action_options?.view,
    },
  },
];

export default MasterRoutes;
